<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <v-btn depressed large block color="white" class="ma-0" v-on="on">
          Log in as testator
        </v-btn>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Log in as testator</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            Are you sure you want to login as this testator:<br />
            <b>{{ testatorName }}</b>
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                rounded
                depressed
                :loading="buttonLoading"
                color="primary"
                class="left-edit-btn"
                @click="loginAsTestator()"
              >
                <span>Yes, login as testator</span>
                <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
              </v-btn>

              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                outlined
                color="grey.darken1"
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'LoginAsTestator',
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        dialog: false,
        buttonLoading: false,
      };
    },
    computed: {
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
    },
    methods: {
      loginAsTestator() {
        this.closeDialog();
        this.$emit('loginActioned', this.testator);
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
